
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { EditorState } from '@/types/editor';

@Component
export default class MetaDataInput extends Vue {
  @Prop() content!: EditorState;

  @Mutation('editor/setMetaTitle') setMetaTitle!: Function;
  @Mutation('editor/setMetaDescription') setMetaDescription!: Function;
  @Mutation('editor/setCanonicalUrl') setCanonicalUrl!: Function;
  @Mutation('editor/setTwitterTitle') setTwitterTitle!: Function;
  @Mutation('editor/setTwitterDescription') setTwitterDescription!: Function;
  @Mutation('editor/setOpenGraphTitle') setOpenGraphTitle!: Function;
  @Mutation('editor/setOpenGraphDescription')
  setOpenGraphDescription!: Function;

  get meta_title() {
    return this.content.meta!.meta_title;
  }
  set meta_title(value) {
    this.setMetaTitle(value);
  }
  get meta_description() {
    return this.content.meta!.meta_description;
  }
  set meta_description(value) {
    this.setMetaDescription(value);
  }
  get canonical_url() {
    return this.content.meta!.canonical_url;
  }
  set canonical_url(value) {
    this.setCanonicalUrl(value);
  }

  get twitter_title() {
    return this.content.meta!.twitter_title;
  }
  set twitter_title(value) {
    this.setTwitterTitle(value);
  }
  get twitter_description() {
    return this.content.meta!.twitter_description;
  }
  set twitter_description(value) {
    this.setTwitterDescription(value);
  }

  get open_graph_title() {
    return this.content.meta!.open_graph_title;
  }
  set open_graph_title(value) {
    this.setOpenGraphTitle(value);
  }
  get open_graph_description() {
    return this.content.meta!.open_graph_description;
  }
  set open_graph_description(value) {
    this.setOpenGraphDescription(value);
  }
}
